import type { Price } from '@backmarket/http-api'
import type { GetPickersResponse } from '@backmarket/http-api/src/api-specs-navigation-experience/product/pickers'
import {
  PaymentError,
  type PaymentMethod,
} from '@backmarket/http-api/src/api-specs-payment/payment/payment.types'

/**
 * Filter a list of payment methods by removing those disabled for AB testing (remove Klarna or Affirm)
 */
export function filterABTestedPaymentMethods(
  experiments: Record<string, string>,
  paymentMethods: PaymentMethod[],
  bagPrice: Price | null,
) {
  const filter = (methods: PaymentMethod[], experimentVariation: string) => {
    switch (experimentVariation) {
      case 'withoutScalapay':
        return methods.filter((method) => method.group !== 'scalapay')

      case 'withoutOney10x12x':
        return methods.filter(
          (method) => !['oney10x', 'oney12x'].includes(method.bmCode),
        )

      case 'withoutKonbiniAbove100kYen':
        return bagPrice !== null &&
          bagPrice.currency === 'JPY' &&
          parseFloat(bagPrice.amount) > 100_000
          ? methods.map((method) =>
              method.group === 'konbini'
                ? {
                    ...method,
                    enabled: false,
                    errors: [
                      PaymentError.PRICE_INCOMPATIBLE_KONBINI_THRESHOLD_AB_TEST,
                    ],
                  }
                : method,
            )
          : methods

      default:
        return methods
    }
  }

  let filtered = paymentMethods
  filtered = filter(filtered, experiments['experiment.enableScalapayIT'])
  filtered = filter(filtered, experiments['experiment.enableOney10x12xFR'])
  filtered = filter(filtered, experiments['experiment.konbiniThresholdsJP'])

  return filtered
}

/**
 * remove payement methods that are disabled for AB testing.
 */
export function filterSelectedOfferABTestedPaymentMethods(
  experiments: Record<string, string>,
  selectedOffer: NonNullable<GetPickersResponse['selectedOffer']>,
) {
  if (!selectedOffer.paymentMethods) {
    return selectedOffer
  }

  return {
    ...selectedOffer,
    paymentMethods: filterABTestedPaymentMethods(
      experiments,
      selectedOffer.paymentMethods,
      null,
    ),
  }
}
